import Vue from "vue";
import Vuetify from "vuetify/lib";
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

Vue.use(Vuetify);


const opts = {
    // iconfont: 'mdi',
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        dark    : false,
        themes  : {
            dark: {
                // primary     : '#8bc34a',
                // secondary   : '#ffe18d',
                primary  : '#FFFFFF',
                secondary    : '#303030',
                // secondary    : '#212121',
                accent      : '#FF4081',
                success     : '#4CAF50',
                info        : '#2196F3',
                warning     : '#FFC107',
                error       : '#F44336'
            },
            light: {
                primary    : '#212121',
                // primary    : '#4CAF50',
                // secondary  : '#8BC34A',
                secondary  : '#FFFFFF',
                accent     : '#009688',
                success    : '#4caf50',
                info       : '#2196F3',
                warning    : '#ff9800',
                error      : '#F44336'
            }
        }
    },
}

export default new Vuetify(opts)
